<template>
    <div :class="{'bg-light-gray': isSelected, 'hover-bg-near-white' : !isSelected}" class="bt b--light-gray pointer flex items-center justify-between ph3 ph4-ns" @click="$emit('select')">
        <div class="flex flex-wrap mr2 w-100" style="padding-top:22px; padding-bottom:22px;">
            <div class="flex items-center" v-for="(category, index) in categoryHierarchy" :key="index">
                <div class="bodyCopy" :class="{ b: index === categoryHierarchy.length - 1}">{{ category.name }}</div>
                <div class="ph2 formLabel mid-gray" v-if="index < categoryHierarchy.length - 1"><img style="width:10px" src="@/assets/img/arrow_right_grey_bold.svg"/></div>
            </div>
        </div>
        <div v-if="isSelected">
            <img src="@/assets/img/icon_check_black.svg"/>
        </div >
    </div>

</template>

<script>
export default {
    props: {
        categoryHierarchy: {
            type: Array,
            required: true
        },
        isSelected: {
            type: Boolean,
            default: false
        }
    }
};
</script>
